"use client"

import React, {useEffect, useState} from 'react';
import Header2 from "@/app/(index)/header2";
import cx from "clsx";
import {Noto_Sans_TC, Poppins} from 'next/font/google';
import Footer from "@/app/(index)/footer";
import Bread, {BreadLv3} from "@/app/(index)/bread";
import {Divider, UnstyledButton} from "@mantine/core";
import {ITeamDTO} from "@/form/group";
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import {loadTeam} from "@/service";
import LinkItem from "@/app/(index)/related-links/link";
import {useMediaQuery} from "@mantine/hooks";

const notoSansTC = Noto_Sans_TC({
    weight: ['400', '500', '700', '800', '900'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

const groupName: {[key: string]: {[key: string]: string}} = {
    A: {name1: "政策研究", name2: "政策", name3: "Policy Research"},
    B: {name1: "科研資料服務", name2: "科研資料", name3: "Databases & Information Service"},
    C: {name1: "科產推動服務", name2: "科產推動", name3: "Science & Technology Industry"},
    D: {name1: "創新創業", name2: "創新創業", name3: "Innovation & Entrepreneurship Promotion"},
}

const poppins = Poppins({
    weight: ['400', '500', '700'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});


const Page = ({ params }: { params: { team_id: string, id: string } }) => {
    const { fontSize, lang } = useGlobalStateStore();
    // const loadCurrentFontSize = (s: number, m: number, l: number) => {
    //     if(fontSize == 0) return `text-[${s}px]`;
    //     else if(fontSize == 1) return `text-[${m}px]`;
    //     else if(fontSize == 2) return `text-[${l}px]`;
    // }

    const [entity, setEntity] = useState<ITeamDTO | null>(null);
    const [tab, setTab] = useState<string>('');

    useEffect(() => {
        loadTeam(params.team_id).then(data => {
            setEntity(data);
        })
    }, []);

    const mediaQueryLessSM = useMediaQuery('(min-width: 480px)');
    return (
        <div className={cx("min-h-screen flex flex-col justify-between", notoSansTC.className)}>
            <div>
                <Header2/>
                {
                    mediaQueryLessSM && (
                        <BreadLv3 name_c={`${groupName[params.id]["name1"]} - ${groupName[params.id]["name2"]}核心研究團隊`}
                                  name_e={`${groupName[params.id]["name3"]} - ${groupName[params.id]["name3"]} Division`}
                                  name_c_lv2={`${entity?.name}`}
                                  name_e_lv2={`${entity?.nameEn}`}
                                  lv1Link={`/group/${params.id}`}
                        />
                    )
                }

                {/*<div className="w-[1250px] mx-auto mb-[60px]">*/}
                <div
                    className={cx("mx-auto mb-[60px]", mediaQueryLessSM ? 'w-[1250px]' : 'w-full mt-[100px] px-[10px]')}>
                    <div
                        className="bg-[url('/images/title_topBG.png')] bg-[length:100%_5px] bg-no-repeat bg-top inline-block pt-[15px] pb-[45px] text-[#5b5b5b] text-[35px] font-bold">
                        {lang == "tw" ? entity?.name : entity?.nameEn}
                    </div>

                    <div className="text-[20px] leading-[40px] text-justify">
                        {lang == "tw" ? entity?.intro : entity?.introEn}
                    </div>

                    {!entity?.contactDisabled && (
                        <>
                            <Divider color={"#cedbdc"} my={35} mb={30}/>

                            <div className="font-bold text-[20px]">{lang == "tw" ? "聯絡窗口" : "Contact"}</div>
                            <div className="flex gap-1 items-baseline">
                                <div className="text-[#8d7f4c] font-bold text-[26px]">
                                    {lang == "tw" ? entity?.contactName : entity?.contactNameEn}
                                </div>
                                <div className="text-[#8d7f4c] font-bold text-[20px]">
                                    {entity?.contactPhone}
                                </div>
                            </div>
                            <UnstyledButton component="a" href={`mailto:${entity?.contactEmail}`}>
                                <div
                                    className={cx("text-[20px] text-[#aaa] font-normal", poppins.className)}>
                                    {entity?.contactEmail}
                                </div>
                            </UnstyledButton>
                        </>
                    )}
                </div>


                {
                    ((entity?.relatedLinkList?.filter(item => ( (lang == "tw" && item.language == "A") || (lang == "en" && item.language == "B"))).length ?? 0) > 0) && (
                        <div className={cx("bg-[#f2f5f6] pt-[45px]", mediaQueryLessSM ? '' : 'px-[10px]')}>
                            <div className="w-[1250px] mx-auto pb-[100px]">
                                <div className="font-bold text-[27px]">{lang == "tw" ? "相關連結" : "Related"}</div>
                                <div className="mt-[30px]">
                                    {
                                        entity?.relatedLinkList?.filter(item => ( (lang == "tw" && item.language == "A") || (lang == "en" && item.language == "B")))?.map((item, idx) => (
                                            <LinkItem key={`link-${idx}`} name={item.name} link={item.linkUrl}/>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>


            <Footer/>
        </div>
    );
}

export default Page
